export default "__VITE_ASSET__Djya1JyT__"